export default "__VITE_ASSET__DyEZqQNk__"